/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESFI.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_ACES_FI_CHAP_APPLIED = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESFI/FETCH_ACES_FI_CHAP_APPLIED`
);

export { FETCH_ACES_FI_CHAP_APPLIED };
